import { render, staticRenderFns } from "./StudiesList.vue?vue&type=template&id=74f2a46a&"
import script from "./StudiesList.vue?vue&type=script&lang=js&"
export * from "./StudiesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports